import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=3674b214"
import script from "./PostEdit.vue?vue&type=script&lang=js"
export * from "./PostEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports